import { Injectable, inject } from '@angular/core';
import { ApiRequestOptions, ApiService } from '@services/api.service';
import { EndPoints } from '@services/EndPoints';
import { AdminRequestDto, AdminRequestPatchedDto, AdminDto, PaginatedAdminListDto } from '../dtos/admins.dto';
import { Helpers } from '@utils/helpers';

@Injectable({ providedIn: 'root' })
export class AdminProvider {
  private readonly api = inject(ApiService);

  async getAdmins(options : { page?: number , page_size?: number, params?: any}): Promise<PaginatedAdminListDto | null> {
    try {
      options.page = options.page || 1;
      options.page_size = options.page_size || 50;
      return await this.api.get<PaginatedAdminListDto>({ url: EndPoints.getAdmins, queryParams: options });
    } catch (error) {
      console.error('Error al obtener admins:', error);
      return null;
    }
  }

  async createAdmin(dto: Partial<AdminRequestDto>): Promise<AdminDto | { error: string }> {
    try {
      dto.username = dto.email;
       const { image, ...rest } = dto;
      var body: any = {...rest};
      if(image){
        body.image = await Helpers.fileToBase64(image, true, true);
      }
      const options: ApiRequestOptions = {
        url: EndPoints.createAdmin,
        body,
      };

      return await this.api.post<AdminDto>(options);
    } catch (error: any) {
      console.error('Error al crear admin:', error);
      const message = error?.error?.message || error?.message || '';
      return { error: message };
    }
  }

  async getAdmin(adminId: number): Promise<AdminDto | null> {
    try {
      return await this.api.get<AdminDto>({ url: EndPoints.getAdmin, queryParams: { adminId } });
    } catch (error) {
      console.error('Error al obtener admin:', error);
      return null;
    }
  }

  async updateAdmin(adminId: number, dto: Partial<AdminRequestPatchedDto>): Promise<AdminDto | { error: string }> {
    try {
      const { image, ...rest } = dto;
      var body: any = {...rest};
      if(image){
        body.image = await Helpers.fileToBase64(image, true, true);
      }
      const options: ApiRequestOptions = {
        url: EndPoints.updateAdmin,
        queryParams: { adminId },
        body,
      };

      return await this.api.patch<AdminDto>(options);
    } catch (error: any) {
      console.error('Error al actualizar admin:', error);
      const message = error?.error?.message || error?.message || '';
      return { error: message };
    }
  }

  async deleteAdmin(adminId: number): Promise<boolean> {
    try {
      await this.api.delete({ url: EndPoints.deleteAdmin, queryParams: { adminId } });
      return true;
    } catch (error) {
      console.error('Error al eliminar admin:', error);
      return false;
    }
  }

  async exportAdminsCSV(): Promise<Blob | null> {
    try {
      // Si necesitas headers especiales para CSV, agrégalos aquí
      return await this.api.get<Blob>({ url: EndPoints.exportAdminsCSV });
    } catch (error) {
      console.error('Error al exportar admins CSV:', error);
      return null;
    }
  }
}
